import { useContext } from 'react'
import { UserListModel } from 'src/models/user.models'

import {
  UserContext,
  UserContextActions,
  UserContextAuthenticatedState,
  UserContextValue,
} from './UserProvider'

export function useUser(): UserContextValue {
  const user = useContext(UserContext)

  return user
}

export function useCurrentUser(): UserListModel | undefined {
  const user = useContext(UserContext)

  return user.authenticated ? user.currentUser : undefined
}

type AuthenticatedUser = UserContextAuthenticatedState & UserContextActions

export function useAuthedUser(): AuthenticatedUser {
  const user = useContext(UserContext)

  if (!user.authenticated) {
    // Note: We can throw in expiry/logout/redirect logic here if a user tries to access
    // a page that is protected and they're not authenticated
    throw Error(
      'Attempted to use useAuthedUser() while user is unauthenticated',
    )
  }

  return user
}
